/** Generated titles fit the sync field's 200 UTF-16 units without splitting a Unicode scalar. */
export function defaultSessionTitle(repo: string | null, branch: string | null): string | null {
  if (repo === null) return null;
  const title = (branch === null ? repo : `${repo} · ${branch}`).slice(0, 200);
  return /[\uD800-\uDBFF]$/.test(title) ? title.slice(0, -1) : title;
}
